const SF_LOGOUT_FINISH_PARAM = 'sf_logout_finish=1';

function trimTrailingSlash(url: string | undefined): string {
  return url?.trim().replace(/\/$/, '') ?? '';
}

export function getCrmBaseUrl(): string {
  return trimTrailingSlash(process.env.NEXT_PUBLIC_CRM_URL);
}

function withSfLogoutFinish(url: string): string {
  if (!url) {
    return `?${SF_LOGOUT_FINISH_PARAM}`;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${SF_LOGOUT_FINISH_PARAM}`;
}

export function getCrmLogoutUrl(): string {
  const baseUrl = trimTrailingSlash(process.env.NEXT_PUBLIC_CRM_LOGOUT_URL) || `${getCrmBaseUrl()}/logout`;

  return withSfLogoutFinish(baseUrl);
}

export function getCrmMaintenanceUrl(): string {
  return `${getCrmBaseUrl()}/maintenance`;
}

export function getAppCrmLogoutPath(redirectUrl: string): string {
  return `/crm-logout/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function getCrmBackToSuperAdminUrl(): string {
  const baseUrl = getCrmBaseUrl();

  if (!baseUrl) {
    return getCrmLogoutUrl();
  }

  return `${baseUrl}/impersonate/leave`;
}

export function getAppBackToAdminPath(): string {
  return '/back-to-admin/';
}

export function getAppBackToSuperAdminPath(): string {
  return '/back-to-superadmin/';
}
